// src/components/CardComponent.js
import React from "react";
import { useNavigate } from "react-router-dom";
// import "../reviewtest.css"


function Reviewtestcard({ news }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (news.source) {
      navigate(`/currentaffairs/${news.id}`);
    }
  };

  const handleAltClick = () => {
    if (news.source) {
      navigate(`/currentaffairs/${news.id}`);
    }
  };

  return (
    <div className="news-card" style={{width:"250px",}}>
      <div className="news-content" >
          <p className="news-title">LessonPlanId: {news.lessonPlanId}</p>
          <p className="news-text">
           Attempt: {news.Attemp}
          </p>
  
           <button
           style={{marginTop:"auto"}}
          
          className="btn-question btm-four-wgt "
          onClick={() => window.location.href = news.reviewUrls[0]}
          
        >
          <img src="/assets/images/eassy-guidance-new.svg"  />
          <span className="p-type-title ms-2">
          Review Test
          </span>
        </button>
        </div>
    </div>
  );
}

export default Reviewtestcard;
